import { createState } from '../context-utils';
import { CreateProductType } from './create-product-types';

export const CreateProductShowSelector = createState((state: CreateProductType) => {
  return state.show;
});

export const CreateProductVendorIdSelector = createState((state: CreateProductType) => {
  return state.vendorId;
});

export const CreateProductActionsSelector = createState((state: CreateProductType) => {
  return state.actions;
});

export const CreateProductVendorSelector = createState((state: CreateProductType) => {
  return state.vendor;
});

export const CreateProductTypeSelector = createState((state: CreateProductType) => {
  return state.type;
});

export const CreateProductPaymentProviderSelector = createState((state: CreateProductType) => {
  return state.paymentProvider;
});

export const CreateProductModeSelector = createState((state: CreateProductType) => {
  return state.mode;
});

export const CreateProductCurrentSelector = createState((state: CreateProductType) => {
  return state.product;
});

export const CreateProductPartnerSelector = createState((state: CreateProductType) => {
  return state.partnerVendorId;
});
